export const signInStyles = {
  fontSize: '2rem',
  fontWeight: '500',
  color: 'text.primary', // Ensures the title adapts to the dynamic theme
};

export const emailStyles = {
  fontSize: '0.9rem',
  fontWeight: '400',
  color: 'text.secondary', // Replaced hardcoded grey #667085
};

export const labelStyles = {
  color: 'text.secondary', // Replaced hardcoded dark color #212636
  fontSize: '1rem',
  '&.Mui-focused': {
    color: 'primary.main', // Connects focused label color cleanly to your brand color
  },
};

export const inputStyles = {
  '& .MuiOutlinedInput-notchedOutline': {
    borderColor: 'divider', // Replaced hardcoded #B5C0D0 with theme divider token
  },
  '&:hover .MuiOutlinedInput-notchedOutline': {
    borderColor: 'primary.light',
  },
  '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
    borderColor: 'primary.main',
  },
};

export const buttonStyles = {
  alignSelf: 'center',
  width: '40%',
  color: '#ffffff',
  '&:hover': {
    backgroundColor: 'primary.dark', // Replaced browser-hardcoded 'blue' with your dynamic primary hover color
  },
};
